export function isSessionSelectable(session) {
    return session.is_selectable;
}